import {ApiResponse, ApiReturnObject} from '../types/global';
import {baseReturnObject} from '../constants/global';
import { buildApiUrl } from '../config/api';

const sleep = (time: number) => new Promise(func => setTimeout(func, time));
export const retryErrorCodeWaitTime: Array<number> = [300, 300, 600, 900, 1500];

export async function callFetch(url: RequestInfo, numOfRetries: number, totalNumberOfRetries: number, options: RequestInit = {}): Promise<ApiReturnObject> {

    const returnObject = {...baseReturnObject};
    try {
        const response = await fetch(url, options);
        if (response.ok) {
            returnObject.response = await response.json();
            returnObject.success = true;
            returnObject.status = response.status;
            return returnObject;
        }
        else if (numOfRetries > 0) {
            const index = totalNumberOfRetries - numOfRetries;
            await sleep(retryErrorCodeWaitTime[index]);
            return callFetch(url, numOfRetries - 1, totalNumberOfRetries, options);
        }
        else {
            // Try to get error message from response
            let errorMessage = 'Unable to process request';
            try {
                const errorData = await response.json() as ApiResponse;
                returnObject.response = errorData;
                if ('message' in errorData && errorData.message) {
                    errorMessage = errorData.message;
                    // Add validation errors if present
                    if ('errors' in errorData && errorData.errors) {
                        const errorDetails = Object.values(errorData.errors).flat();
                        const firstError = errorDetails[0];
                        // Prefer the first validation error as the main message when the API sent a generic validation message
                        const genericValidationMessages = [
                            'The given data was invalid.',
                            'The request data was invalid.',
                            'Validation failed.',
                        ];
                        if (firstError && genericValidationMessages.some((g) => errorMessage === g)) {
                            errorMessage = firstError;
                        } else if (errorDetails.length > 0 && errorMessage !== firstError) {
                            errorMessage += `: ${errorDetails.join(', ')}`;
                        }
                    }
                }
            } catch (parseError) {
                // If response isn't JSON, use status-based message
                if (response.status === 0) {
                    errorMessage = 'Network error: Unable to connect to server. Please check if the Laravel server is running.';
                } else if (response.status === 404) {
                    errorMessage = `API endpoint not found: ${url}`;
                } else if (response.status === 422) {
                    errorMessage = 'Validation error: The request data is invalid.';
                } else if (response.status === 500) {
                    errorMessage = 'Server error: Please try again later.';
                } else {
                    errorMessage = `Request failed with status ${response.status}`;
                }
            }
            returnObject.error = new Error(errorMessage);
            returnObject.success = false;
            returnObject.status = response.status;
            return returnObject;
        }
    } catch(e) {
        returnObject.success = false;

        return returnObject;
    }
}

export function fetchAPI(url: string, options: RequestInit = {}, numOfRetries = 0): Promise<ApiReturnObject> {
    // Build the full API URL
    const fullUrl = buildApiUrl(url);
    
    if(numOfRetries > 5){
        numOfRetries = 5;
    }

    return callFetch(fullUrl, numOfRetries, numOfRetries ,options)
        .then((res) => {
            return res;
        });
}
